import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledDropdownContainer = styled(Flex)<{ width?: string | number }>`
    position: relative;
    width: ${({ width }) => (typeof width === "number" ? `${width}px` : width)};

    .DropdownButton--opened {
        .DropdownButton-text {
            color: ${colorsPalettes.carbon["400"]};
        }
    }
`;
